

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { ModalConstants } from '@/core/constants';
import { Role } from '@/core/security/Role';

import NavigationHeader from '@/components/dashboard/navigation/NavigationHeader.vue';
import SideNavigation from '@/components/dashboard/navigation/SideNavigation.vue';
import TopMenu from '@/components/dashboard/menus/TopMenu.vue';

import ProfileMenu from '@/components/dashboard/ProfileMenuOverlay.vue';
import SelectRealm from '@/components/dashboard/SelectRealm.vue';
import UserModeration from '@/components/dashboard/users/UserModerationOverlay.vue';
import BuildProcessWindow from '@/components/dashboard/BuildProcessWindow.vue';
import RealmLogHistoryOverlay from '@/components/dashboard/RealmLogHistoryOverlay.vue';

@Component({
    components: {
        NavigationHeader,
        SideNavigation,
        TopMenu,
        SelectRealm,
        ProfileMenu,
        UserModeration,
        BuildProcessWindow,
        RealmLogHistoryOverlay
    }
})
export default class Dashboard extends Vue {
	delayNotifcation = true;

	@Prop() isLoggedIn!: boolean;

	get isAuthenticated(): boolean {
	    return this.isLoggedIn && UserModule.user != null && UserModule.user.HasRole([Role.Administrator]);
	}

	async created() {
	    if (this.isAuthenticated) {
	        if (RealmsModule.realmLists.length === 0) {
	            await RealmsModule.GetRealmLists();

	            if (!RealmsModule.ActiveRealm && this.isLoggedIn) {
	                this.$bvModal.show(ModalConstants.SelectRealm);
	            }
	        }
	    }
	}

	mounted() {
	    setTimeout(() => (this.delayNotifcation = false), 500);
	}
}
